import React, { Component } from 'react';
import Buscador from './componentes/Buscador';
import Resultado from './componentes/Resultado';

class App extends Component {

  state = {
    termino : '',
    imagenes : [],
    pagina: ''
  }

  paginaAnterior = () => {
    let pagina = this.state.pagina;
    if (pagina === 1) return null;
    pagina -= 1;
    this.setState({
      pagina
    }, ()=>{
      this.consultarApi();
    });
    console.log(pagina)
  }

  paginaSiguiente = () => {
    let pagina = this.state.pagina;
    pagina += 1;
    this.setState({
      pagina
    }, ()=>{
      this.consultarApi();
    });
    console.log(pagina)
  }

  consultarApi = () => {
    const clave='563492ad6f9170000100000189c8ed3f630940b691270187661ae56c';
    const pagina=this.state.pagina;
    const url=`https://api.pexels.com/v1/search?query=${this.state.termino}&page=${pagina}&per_page=12`;
    console.log(url)
    fetch(url,{
      method:'GET',
      headers:{
        Authorization: clave
      }
    })
      .then(respuesta => respuesta.json())
      .then(resultado => this.setState({imagenes: resultado.photos}))
    }

  datosBusqueda=(termino)=>{
    this.setState({
      termino: termino,
      pagina: 1
    }, ()=>{
      this.consultarApi();
    })
  }

  render(){
    return (
      <div className="App">
        <div className="caja">
          <h1>Buscador de imagenes</h1>
          <Buscador
            datosBusqueda={this.datosBusqueda}
          />
        </div>
        <Resultado
          imagenes={this.state.imagenes}
          paginaAnterior={this.paginaAnterior}
          paginaSiguiente={this.paginaSiguiente}
        />
      </div>
    );
}
}

export default App;
